import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hud-card" }
const _hoisted_2 = { class: "hud-card__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "hud-card__frame hud-card__frame--back" }, null, -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "hud-card__frame hud-card__frame--mid" }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "hud-card__frame hud-card__frame--front" }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "hud-card__scan" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "meta", {}, undefined, true),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])
  ]))
}